import {Component, Input, EventEmitter, Output, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import {HeaderSearchComponent} from '../header/components/header-search/header-search.component';
import {HeaderNotificationComponent} from '../header/components/header-notification/header-notification.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SubmenuComponent} from '../submenu/submenu.component';
import {Observable, of} from 'rxjs';
import {User} from '@core/model/user/user';
import { DoplanerModules } from '@core/enums/modules.enum';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent implements OnInit{
  @Input() open = false;
  @Output() submenuClosed = new EventEmitter<void>(); // new Output
  currentUrl = '';
  activeSubmenu: string | null = null;
  public submenuDialogRef: MatDialogRef<SubmenuComponent> | null = null;
  user$: Observable<User>;
  moduleCodes = DoplanerModules;

  constructor(private router: Router,private authService:AuthService, private dialog: MatDialog, public auth: AuthService,) {
    // Listen to route changes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit(): void {
    this.auth.user$.subscribe((x) => {
      this.user$ = of(x);
    });
  }

  isTicketsActive(): boolean {
    return this.router.url.startsWith('/tickets/');
  }
  isTimeTrackingActive(): boolean {
    return this.router.url.startsWith('/time-tracking/');
  }
  
  isHrActive(): boolean {
    return this.router.url.startsWith('/hr/');
  }

  isRouteActive(section: string): boolean {
    const lower = section.toLowerCase();
    if (!this.currentUrl) return false;

    if (lower === this.moduleCodes.Tickets) {
      return this.currentUrl.startsWith('/tickets') && !this.currentUrl.startsWith('/tickets-setup');
    }
    if (lower === this.moduleCodes.TicketSetup) {
      return this.currentUrl.startsWith('/tickets-setup');
    }
    if (lower === this.moduleCodes.Employee) {
      return this.currentUrl.startsWith('/employees');
    }
    if (lower === this.moduleCodes.Finance) {
      return this.currentUrl.startsWith('/finance');
    }
    if (lower === this.moduleCodes.TimeTracking) {
      return this.currentUrl.startsWith('/time-tracking');
    }
    return false;
  }

  isClicked(section: string): boolean {
    // Only gray highlight if submenu is open AND route doesn’t match
    return this.activeSubmenu === section.toLowerCase() && !this.isRouteActive(section);
  }






  canViewPermission(permission: string): boolean {
    const canView =
      this.authService.hasPermission('read:' + permission) ||
      this.authService.hasPermission('write:' + permission);

    return canView;
  }

  SetDialogWidth(): string {
    let returnWidth;
    const windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '94vw';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '94vw';
        break;
      }
      default:
        returnWidth = '600px';
    }
    return returnWidth;
  }

  headerSearch(): void {
    const width = this.SetDialogWidth()
    this.dialog.open(HeaderSearchComponent, {
      minWidth: width,
      width: width,
      minHeight: '600px',
      hasBackdrop: true,
    });
  }

  SetDialogWidthNotification(): string {
    let returnWidth;
    const windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '94vw';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '94vw';
        break;
      }
      default:
        returnWidth = '500px';
    }
    return returnWidth;
  }

  headerNotification(): void {
    this.closeSubmenu();
    const width = this.SetDialogWidthNotification()
    this.dialog.open(HeaderNotificationComponent, {
      minWidth: width,
      width: width,
      minHeight: '600px',
      maxHeight: '600px',
      hasBackdrop: true,
      position: {
        top: '50px',
        right: '60px'
      }
    });
  }

  openSubmenu(type: string, title: string) {
    const normalizedType = type.toLowerCase(); //  normalize all keys
    this.activeSubmenu = normalizedType; // always update sidebar active state
    if (this.submenuDialogRef) {
      this.submenuDialogRef.componentInstance.updateData(normalizedType, title);
      return;
    }
    this.submenuDialogRef = this.dialog.open(SubmenuComponent, {
        width: 'calc(100vw - 64px)',
        maxWidth: 'calc(100vw - 64px)',
        height: 'calc(100lvh - 58px)',
        hasBackdrop: false,
        panelClass: 'submenu-dialog-panel',
      position: { top: '50px', left: '57px', right: '7px' },
      data: { selectedType: normalizedType, selectedTitle: title  }
      });

    // Reset ref when closed
    this.submenuDialogRef.afterClosed().subscribe(() => {
      this.submenuDialogRef = null;
      this.activeSubmenu = null; // clear active when closed
      this.submenuClosed.emit(); //  Notifies LayoutComponent
    });

  }

  public closeSubmenu() {
    if (this.submenuDialogRef) {
      this.submenuDialogRef.close();
    }
  }

}
